import React from "react";
import { Box, Typography, Grid, Card } from "@mui/material";
import { useTranslation } from "react-i18next";
import globalStyles from "../../../global";
import { getResponsiveSize } from "../../../utils/responsive";

const ServiceToggle = () => {
  // const [activeService, setActiveService] = useState('fabric');
  const { t, i18n } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const isRTL = i18n.language === "ar";

  const styles = {
    container: {
      maxWidth: "1200px",
      mx: "auto",
      px: 2,
      my: 8,
      direction: isRTL ? "rtl" : "ltr",
    },
    toggleContainer: {
      display: "flex",
      flexDirection: { xs: "column", sm: isRTL ? "row-reverse" : "row" },
      maxWidth: "600px",
      mx: "auto",
      mt: 3,
      mb: 4,
      border: "1px solid",
      borderColor: "grey.200",
      borderRadius: 1,
      overflow: "hidden",
    },
    toggleButton: (isActive) => ({
      flex: 1,
      py: 1.5,
      fontFamily: globalStyles.fonts.primary,
      fontSize: {
        xs: getResponsiveSize(14),
        sm: getResponsiveSize(16),
        md: getResponsiveSize(18),
      },
      fontWeight: 500,
      backgroundColor: isActive ? "green.50" : "white",
      color: isActive ? globalStyles.colors.army_green : "grey.400",
      "&:hover": {
        backgroundColor: isActive ? "green.50" : "grey.50",
      },
      transition: "all 0.2s",
    }),
    contentArea: {
      mt: 2,
      mx: "auto",
      maxWidth: "1200px",
    },
    serviceCard: {
      border: "1px solid",
      borderColor: "grey.200",
      borderRadius: 2,
      py: 4,
      px: 2,
      height: "100%",
      transition: "all 0.3s ease",
      cursor: "pointer",
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "#e0f2e9", // light green background on hover
        borderColor: "#003A26", // dark green border on hover
      },

      "@media (hover: none)": {
        "&:active": {
          backgroundColor: "#e0f2e9", // same effect for mobile tap
          borderColor: "#003A26",
        },
      },
    },
    iconContainer: {
      display: "flex",
      justifyContent: isRTL ? "flex-end" : "flex-start",
      mb: { xs: 1.5, sm: 2 },
    },
    serviceIcon: {
      width: { xs: "64px", sm: "72px", md: "80px" },
      height: { xs: "64px", sm: "72px", md: "80px" },
      objectFit: "contain",
      borderRadius: 1,
    },
    serviceTitle: {
      fontSize: {md:"24px",sm:"22px", xs:"18px"},
      color: globalStyles.colors.army_green,
      fontFamily: globalStyles.fonts.primary,
      fontWeight: 600,
      mt: 1,
    },
    serviceContent: {
     fontSize: { sm: "18px", xs: "14px" },
      color: "#666666",
      mt: { xs: 1, sm: 1.5 },
    },
    homeCareMessage: {
      textAlign: "center",
      py: { xs: 4, sm: 6 },
    },
  };

  const services = [
    {
      title: t("servicesSr.steamPress.title"),
      content: t("servicesSr.steamPress.content"),
      icon: "iron.png",
    },
    {
      title: t("servicesSr.laundryByKg.title"),
      content: t("servicesSr.laundryByKg.content"),
      icon: "LaundryByKg.png",
    },
    {
      title: t("servicesSr.premiumLaundry.title"),
      content: t("servicesSr.premiumLaundry.content"),
      icon: "premiumlaundry_icon.png",
    },
    {
      title: t("servicesSr.dryCleaning.title"),
      content: t("servicesSr.dryCleaning.content"),
      icon: "dry.png",
    },
    {
      title: t("servicesSr.carpetCleaning.title"),
      content: t("servicesSr.carpetCleaning.content"),
      icon: "CarpetClean.png",
    },

    {
      title: t("servicesSr.sofaCleaning.title"),
      content: t("servicesSr.sofaCleaning.content"),
      icon: "SofaClean.png",
    },

    {
      title: t("servicesSr.bagCleaning.title"),
      content: t("servicesSr.bagCleaning.content"),
      icon: "bagcleaning_icon.png",
    },
    {
      title: t("servicesSr.shoeCleaning.title"),
      content: t("servicesSr.shoeCleaning.content"),
      icon: "shoecleaning_icon.png",
    },
  ];

  return (
    <Box sx={styles.container}>
      {/* Toggle Buttons */}
      {/* <Box sx={styles.toggleContainer}>
        <Button
          sx={styles.toggleButton(activeService === 'fabric')}
          onClick={() => setActiveService('fabric')}
        >
          {t('services2.toggleButtons.fabricCare')}
        </Button>
        <Button
          sx={styles.toggleButton(activeService === 'home')}
          onClick={() => setActiveService('home')}
        >
          {t('services2.toggleButtons.homeCare')}
        </Button>
      </Box> */}

      {/* Content Area */}
      <Box sx={styles.contentArea}>
        {/* {activeService === 'fabric' ? (
          <Grid container spacing={3}>
            {services.map((service, index) => (
              <Grid item xs={12} sm={6} lg={4} key={index}>
                <Card sx={styles.serviceCard}>
                  <Box sx={styles.iconContainer}>
                    <Box
                      component='img'
                      src={`${imageBaseUrl}${service.icon}`}
                      alt={service.title}
                      sx={styles.serviceIcon}
                    />
                  </Box>
                  <Typography sx={styles.serviceTitle}>
                    {service.title}
                  </Typography>
                  <Typography sx={styles.serviceContent}>
                    {service.content}
                  </Typography>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography sx={styles.homeCareMessage}>
            {t('services2.homeCareMessage')}
          </Typography>
        )} */}
        <Grid container spacing={2}>
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <Card sx={styles.serviceCard}>
                <Box sx={styles.iconContainer}>
                  <Box
                    component="img"
                    src={`${imageBaseUrl}${service.icon}`}
                    alt={service.title}
                    sx={styles.serviceIcon}
                  />
                </Box>
                <Typography sx={styles.serviceTitle}>
                  {service.title}
                </Typography>
                <Typography sx={styles.serviceContent}>
                  {service.content}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ServiceToggle;
